import { getRelatoriosEmAberto, Relatorio } from "../services/relatorio";
import { useQuery } from "react-query"

export function useRelatoriosEmAberto({ page, pageSize }: { page: number, pageSize: number }) {
  let skip = 0;

  if (page > 1) {
    skip = (page - 1) * pageSize;
  }

  return useQuery(
    ["relatorios-em-aberto", page],
    () => getRelatoriosEmAberto({ skip, take: pageSize }),
    {
      staleTime: 1000 * 60 * 5
    }
  )
}
